import { AxiosInstance } from 'axios';

import { JobFinanceServicesEndpoint, UpdateJobPriceRequest } from './JobFinanceServices.types';

export class JobFinanceServices implements JobFinanceServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  updateRevenue(request: UpdateJobPriceRequest) {
    return this.instance.put(`/job/${request.routeParams.jobGuid}/fin/tariff`, request.body);
  }

  updateBasePayCost(request: UpdateJobPriceRequest) {
    return this.instance.put(`/job/${request.routeParams.jobGuid}/fin/carrier-pay`, request.body);
  }
}
